import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { css } from 'styled-components';
import { colorBlue10, colorGrey60 } from '../../../../../tokens';
import { token } from '../../../../../system/mixins';
export var getMenuElementOverride = function getMenuElementOverride(_ref) {
  var selected = _ref.selected,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      depthLevel = _ref.depthLevel;
  var result = {};
  result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        &:hover {\n            background-color: ", ";\n        }\n    "])), colorGrey60);

  if (secondary || tertiary || depthLevel > 1) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            .MenuElement-ExpansionHandle {\n                color: ", ";\n            }\n        "])), result, colorBlue10);
  }

  if (selected) {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n        "])), result, colorGrey60);
  } else {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n        "])), result, token('body.backgroundColor'));
  }

  return result;
};